import React from "react";
//MUI
import { Box, Grid, Typography, Button } from "@mui/material";
//画像
import HomeIcon from "@mui/icons-material/Home";
import Matto2 from "./material/matto2.jpg";
import Tobibako1 from "./material/tobibako1.jpg";
import Tetubou2 from "./material/tetubou2.jpg";
import Toranporin3 from "./material/toranporin3.jpg";
import CharacterRed from "./material/character_red.png";
import CharacterBlue from "./material/character_blue.png";
import CharacterPurple from "./material/character_purple.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { NotoSansJp, QuickSand } from "./TextStyle";
import DocumentMeta from "react-document-meta";
import { useBranch, Navigate } from "./useBranch";

const sections = [
  {
    title: "マット運動",
    description:
      "前転、倒立などの基礎運動を行いながら、お子様のレベルに応じて簡単な技から難しい技にチャレンジします。マット運動は両手と両足、背中やお尻を使って体を支えたりはね返したりします。全身を使って色々な動きをすることでさまざまな能力を育みます。",
    image: Matto2,
    triangleColor: "#F9E95B",
    borderColor: "#FF6BB5",
    marginTop: "150px",
  },
  {
    title: "跳び箱",
    description:
      "走る、跳ぶなどの基本的な動作を通じて自分の身体を思い通りに動かす力を身につけます。習熟度に応じて開脚跳びやお子様一人ひとりの実力に応じた独自の補助法だから怪我なく安全に練習します。",
    image: Tobibako1,
    triangleColor: "#A2D4F5",
    borderColor: "#93C8E5",
    marginTop: "100px",
  },
  {
    title: "鉄棒",
    description:
      "逆上がりや懸垂などを通して、腕力や体幹を鍛えます。楽しみながら達成感を味わえるように工夫されています。",
    image: Tetubou2,
    triangleColor: "#FBB1C1",
    borderColor: "#ADD578",
    marginTop: "100px",
  },
  {
    title: "トランポリン",
    description:
      "空中姿勢と着地を繰り返し練習し、反応速度と美しい姿勢を養成。楽しさと爽快感で笑顔が止まりません。",
    image: Toranporin3,
    triangleColor: "#FBB1C1",
    borderColor: "",
    marginTop: "100px",
  },
];

const CoursesFees = () => {
  const state = useBranch();
  const isSmartphone = useMediaQuery("(max-width:767px)");

  if (state.status === "loading") return null;
  if (state.status === "notfound") return <Navigate to="/" replace />;
  const branch = state.branch;
  if (!branch.showCoursesFees) return <Navigate to={`/${branch.id}`} replace />;

  const meta = {
    title: `${branch.roomName}｜土日【本格的】体操教室と料金`,
    description: branch.coursesFeesDescription,
    canonical: `https://tht-group.co.jp/${branch.id}/coursesfees`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: [
          ...branch.top.regionKeywords,
          "土日だけ体操教室",
          "キッズ・ジュニア初級",
          "ジュニア",
          "クッション・バク転",
          "選手大会",
          "体操教室",
          "バク転教室",
          "マット運動",
          "跳び箱",
          "鉄棒",
          "トランポリン",
          "土日 体操",
          "本格的 体操クラス",
          "少人数制",
          "体幹 強化",
          "柔軟性 向上",
          "無料体験",
          "体験レッスン",
          "料金一覧",
        ].join(","),
      },
    },
  };

  return (
    <>
      <DocumentMeta {...meta}>
        <Box sx={{ width: "100vw" }}>
          <Grid
            container
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100vw" }}>
              <Grid
                container
                direction="column"
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{ width: "100%", mt: isSmartphone ? "40px" : "100px" }}
                >
                  <Grid
                    container
                    direction="column"
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                      p: isSmartphone ? "0% 7% 6% 7%" : "0",
                    }}
                  >
                    <Typography
                      component="h1"
                      sx={{
                        color: "darkorange",
                        fontSize: isSmartphone ? "20px" : "35px",
                        fontWeight: "bold",
                        pt: isSmartphone ? "0" : "50px",
                        mb: isSmartphone ? "10px" : "20px",
                        ...NotoSansJp,
                      }}
                    >
                      {branch.roomName}｜土日【本格的】体操教室と料金
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#333333",
                        mb: "40px",
                      }}
                    >
                      <HomeIcon fontSize="small" />
                      <Typography
                        sx={{ fontSize: isSmartphone ? "14px" : "16px", mx: 1 }}
                      >
                        {">"}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#333333",
                          fontWeight: 500,
                          fontSize: isSmartphone ? "14px" : "16px",
                          ...NotoSansJp,
                        }}
                      >
                        土日【本格的】体操教室と料金
                      </Typography>
                    </Box>

                    <Box sx={{ pt: "30px" }}>
                      <Button
                        component="a"
                        href={branch.freeTrialUrl}
                        sx={{
                          color: "#FFFFFF",
                          bgcolor: "darkgreen",
                          borderRadius: "50px",
                          p: "15px 40px",
                          fontSize: "16px",
                          transition:
                            "background-color 0.3s ease, transform 0.3s ease",
                          ...NotoSansJp,
                          "&:hover": {
                            bgcolor: "#E0B24B",
                            transform: "scale(1.1)",
                            overflow: "hidden",
                            maxWidth: "100%",
                          },
                        }}
                      >
                        無料体験
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        width: isSmartphone ? "100%" : "65%",
                        position: "relative",
                      }}
                    >
                      <img
                        src={CharacterBlue}
                        alt="blue_triangle"
                        style={{
                          position: "absolute",
                          top: isSmartphone ? "440px" : "490px",
                          right: "110px",
                          zIndex: 5,
                          width: isSmartphone ? "20%" : "10%",
                        }}
                      />
                      <img
                        src={CharacterRed}
                        alt="orange_triangle"
                        style={{
                          position: "absolute",
                          bottom: "320px",
                          right: "125px",
                          zIndex: 5,
                          width: isSmartphone ? "20%" : "10%",
                        }}
                      />
                      <img
                        src={CharacterPurple}
                        alt="pink_triangle"
                        style={{
                          display: isSmartphone ? "none" : "block",
                          position: "absolute",
                          top: "800px",
                          right: "420px",
                          zIndex: 5,
                          width: "10%",
                        }}
                      />
                      {sections.map((section, index) => {
                        const isReverse = index % 2 === 1;

                        return (
                          <Box
                            key={section.title}
                            sx={{
                              display: "flex",
                              flexDirection: {
                                xs: "column",
                                md: isReverse ? "row-reverse" : "row",
                              },
                              mt: isSmartphone ? "0" : `${section.marginTop}`,
                            }}
                          >
                            <Box
                              sx={{
                                position: "relative",
                                width: { xs: "100%", md: "50%" },
                                boxSizing: "border-box",
                                m: isSmartphone
                                  ? "30px 0 0 0"
                                  : isReverse
                                    ? "0 0 0 50px"
                                    : "0 50px 0 0 ",
                              }}
                            >
                              <Box
                                component="img"
                                src={section.image}
                                alt={section.title}
                                sx={{
                                  width: "100%",
                                  borderRadius: "20px",
                                }}
                              />
                            </Box>
                            <Box
                              sx={{
                                width: {
                                  xs: "100%",
                                  md: "50%",
                                },
                                boxSizing: "border-box ",
                                color: "#333333",
                                m: isSmartphone
                                  ? "0"
                                  : isReverse
                                    ? "50px 50px 0 0"
                                    : "50px 0 0 50px",
                              }}
                            >
                              <Typography
                                component="h2"
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: isSmartphone ? "20px" : "35px",
                                  mb: isSmartphone ? 0 : 1,
                                  pt: isSmartphone ? "15px" : 0,
                                  borderBottom: `3px dotted ${section.borderColor}`,
                                  display: "inline-block",
                                  ...NotoSansJp,
                                }}
                              >
                                {section.title}
                              </Typography>
                              <Typography
                                sx={{
                                  pt: isSmartphone ? "10px" : "30px",
                                  fontSize: isSmartphone ? "14px" : "16px",
                                  fontWeight: 500,
                                  ...NotoSansJp,
                                }}
                              >
                                {section.description}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                    <Box
                      sx={{
                        width: isSmartphone ? "100%" : "60%",
                        mt: isSmartphone ? "50px" : "150px",
                      }}
                    >
                      <Grid
                        container
                        direction="column"
                        sx={{
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ width: "100%", boxSizing: "border-box" }}>
                          <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Grid
                              container
                              direction={isSmartphone ? "column" : "row"}
                              justifyContent="center"
                            >
                              {[
                                {
                                  title: "キャンペーン",
                                  lines: [
                                    "年会費0円",
                                    "入会金0円",
                                    "Tシャツ約3500円",
                                    ...(branch.id !== "mutsukawa"
                                      ? ["MTT進級テスト 869円(毎月)"]
                                      : []),
                                    "月謝 各コースの体験資料をご覧ください",
                                    "※キャンペーンや月謝詳細は体験資料をご確認ください",
                                  ],
                                },
                                {
                                  title: "通常",
                                  lines: [
                                    "年会費0円",
                                    "入会金11000円",
                                    "Tシャツ約3500円",
                                    ...(branch.id !== "mutsukawa"
                                      ? ["MTT進級テスト 869円(毎月)"]
                                      : []),
                                    "月謝 各コースの体験資料をご覧ください",
                                    "※キャンペーンや月謝詳細は体験資料をご確認ください",
                                  ],
                                },
                              ].map((item, index) => (
                                <Box
                                  key={item.title}
                                  sx={{
                                    width: isSmartphone ? "100%" : "47%",
                                    bgcolor: "#8ABBD6",
                                    boxSizing: "border-box",
                                    borderRadius: "20px",
                                    p: isSmartphone ? "20px" : "50px",
                                    m:
                                      index === 0
                                        ? isSmartphone
                                          ? "0"
                                          : "0 25px 0 0"
                                        : isSmartphone
                                          ? "30px 0 0 0"
                                          : "0 0 0 25px",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: "#FFFFFF",
                                      fontSize: isSmartphone ? "20px" : "35px",
                                      fontWeight: 700,
                                      textAlign: "center",
                                      ...NotoSansJp,
                                    }}
                                  >
                                    {item.title}
                                  </Typography>
                                  <Grid
                                    container
                                    direction={isSmartphone ? "column" : "row"}
                                    alignItems="center"
                                    justifyContent="center"
                                    sx={{ py: "30px", px: "10px" }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "#FFFFFF",
                                        fontWeight: "bold",
                                        fontSize: isSmartphone
                                          ? "18px"
                                          : "20px",
                                        ...NotoSansJp,
                                        whiteSpace: "pre-line",
                                      }}
                                    >
                                      {item.lines.join("\n")}
                                    </Typography>
                                  </Grid>
                                </Box>
                              ))}
                            </Grid>
                            {branch.weekendCourses.map((course) => (
                              <React.Fragment key={course.label}>
                                <Typography
                                  component="h2"
                                  sx={{
                                    color: course.titleColor,
                                    fontSize: isSmartphone ? "25px" : "35px",
                                    fontWeight: 700,
                                    mt: isSmartphone ? "30px" : "100px",
                                    mb: "20px",
                                    textAlign: "center",
                                  }}
                                >
                                  {course.label}
                                </Typography>

                                <Grid container justifyContent="center">
                                  {course.items.map((content) => (
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      key={content.number}
                                    >
                                      <Box
                                        sx={{
                                          bgcolor: course.boxBg,
                                          borderRadius: "20px",
                                          p: isSmartphone
                                            ? "30px 20px"
                                            : "50px 50px 30px",
                                          textAlign: "center",
                                          m:
                                            content.number === 1
                                              ? isSmartphone
                                                ? "0"
                                                : "0 25px 0 0"
                                              : isSmartphone
                                                ? "30px 0 0 0"
                                                : "0 0 0 25px",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            width: isSmartphone ? 74 : 90,
                                            height: isSmartphone ? 74 : 90,
                                            borderRadius: "50%",
                                            backgroundColor: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            mx: "auto",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              color: course.titleColor,
                                              fontSize: isSmartphone
                                                ? "30px"
                                                : "50px",
                                              fontWeight: "bold",
                                              ...QuickSand,
                                            }}
                                          >
                                            {content.number}
                                          </Typography>
                                        </Box>

                                        <Typography
                                          sx={{
                                            fontSize: isSmartphone ? 14 : 16,
                                            color: "#fff",
                                            fontWeight: 500,
                                            m: "5px 0 20px 0",
                                            ...NotoSansJp,
                                          }}
                                        >
                                          対象：{content.target}
                                        </Typography>

                                        <Typography
                                          sx={{
                                            fontSize: isSmartphone ? 16 : 20,
                                            color: "#fff",
                                            fontWeight: 500,
                                            ...NotoSansJp,
                                          }}
                                        >
                                          {content.weektime}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            fontSize: isSmartphone ? 16 : 20,
                                            color: "#fff",
                                            fontWeight: 500,
                                            ...NotoSansJp,
                                          }}
                                        >
                                          {content.holitime}
                                        </Typography>

                                        <Grid
                                          container
                                          direction={
                                            isSmartphone ? "column" : "row"
                                          }
                                          alignItems="center"
                                          justifyContent="center"
                                          sx={{
                                            m: "30px 0 33px 0",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              color: "#fff",
                                              fontWeight: "bold",
                                              fontSize: isSmartphone ? 18 : 20,
                                              whiteSpace: "nowrap",
                                              ...NotoSansJp,
                                            }}
                                          >
                                            {content.count1}
                                          </Typography>
                                          <Box
                                            sx={{
                                              borderTop: `2px dotted ${course.dotColor}`,
                                              mx: 2,
                                              flexGrow: 1,
                                            }}
                                          />
                                          <Typography
                                            sx={{
                                              color: "#fff",
                                              fontWeight: 500,
                                              fontSize: isSmartphone ? 14 : 18,
                                              whiteSpace: "nowrap",
                                              ...NotoSansJp,
                                            }}
                                          >
                                            {content.price1}
                                          </Typography>
                                        </Grid>

                                        {content.explanation && (
                                          <Typography
                                            sx={{
                                              fontSize: 14,
                                              color: "#fff",
                                              mt: 2,
                                              textAlign: "left",
                                              fontWeight: 700,
                                              ...NotoSansJp,
                                            }}
                                          >
                                            {content.explanation}
                                          </Typography>
                                        )}
                                      </Box>
                                    </Grid>
                                  ))}
                                </Grid>
                              </React.Fragment>
                            ))}
                          </Grid>
                        </Box>
                      </Grid>
                    </Box>
                    <Box sx={{ pt: "30px" }}>
                      <Button
                        component="a"
                        href={branch.freeTrialUrl}
                        sx={{
                          color: "#FFFFFF",
                          bgcolor: "darkgreen",
                          borderRadius: "50px",
                          p: "15px 40px",
                          fontSize: "16px",
                          transition:
                            "background-color 0.3s ease, transform 0.3s ease",
                          ...NotoSansJp,
                          "&:hover": {
                            bgcolor: "#E0B24B",
                            transform: "scale(1.1)",
                            overflow: "hidden",
                            maxWidth: "100%",
                          },
                        }}
                      >
                        無料体験
                      </Button>
                    </Box>
                  </Grid>
                </Box>
              </Grid>
            </Box>
          </Grid>
        </Box>
      </DocumentMeta>
    </>
  );
};

export default CoursesFees;
